<div class="fleet-overview">
  <app-dashboard-header></app-dashboard-header>

  <div class="container-fluid fleet-overview__inner">
    <div class="fleet-overview__title-row">
      <h1 class="fleet-overview__title">Fleet Overview</h1>
      <div class="fleet-overview__fleet-select">
        <label class="sr-only" for="fleetSelect">Fleet</label>
        <app-button-dropdown
          leadIcon="fa fa-building-o"
          [options]="fleetOptions"
          [selectedValue]="selectedFleet"
          (selectionChange)="selectFleet($event)"
          [searchable]="true"
          searchPlaceholder="Search customer name…"
          menuMaxHeight="260px"
        ></app-button-dropdown>
      </div>
    </div>

    <div class="row fleet-overview__row">
      <div class="col-lg-6 mb-3">
        <div class="fo-card fo-card--device" style="display: flex; flex-direction: row; justify-content: space-between;">
          <div>
            <div class="fo-card__head-actions mb-2">
              <h2 class="fo-card__heading mb-0">Device Overview</h2>
              <i class="fa fa-info-circle fo-info" aria-hidden="true"></i>
            </div>
            <div class="fo-total-strip">
              <span class="fo-total-strip__value">{{ totalDevices }}</span>
              <span class="fo-total-strip__label">Total Devices</span>
            </div>
            <div class="fo-device-overview">
              <ul class="fo-device-overview__legend">
                <li class="fo-device-overview__legend-item">
                  <div>
                  <span class="fo-state-icon fo-state-icon--good">
                    <i class="fa fa-check-circle"></i>
                  </span>
                  <span class="fo-state-label">Good</span>
                  </div>
                  <strong>{{ deviceStatusSummary.good }}</strong>
                </li>
                <li class="fo-device-overview__legend-item">
                  <div>
                    <span class="fo-state-icon fo-state-icon--risk">
                      <i class="fa fa-warning"></i>
                    </span>
                    <span class="fo-state-label">At Risk</span>
                  </div>
                  <strong>{{ deviceStatusSummary.atRisk }}</strong>
                </li>
                <li class="fo-device-overview__legend-item">
                  <div>
                  <span class="fo-state-icon fo-state-icon--bad">
                    <i class="fa fa-exclamation-circle"></i>
                  </span>
                  <span class="fo-state-label">Attention Required</span>
                  </div>
                  <strong>{{ deviceStatusSummary.attention }}</strong>
                </li>
              </ul>
            </div>
          </div>
          <div class="fo-device-overview__chart">
            <canvas #donutCanvas></canvas>
            <div class="fo-donut-center">
              <strong>{{ totalDevices }}</strong>
              <span>Total Devices</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="fo-card">
          <div class="fo-card__head-actions">
            <h2 class="fo-card__heading mb-0">Devices by Product Code</h2>
            <button type="button" class="btn btn-fo-link">
              View Reports <i class="fa fa-arrow-right"></i>
            </button>
          </div>
          <div class="fo-product-chart-wrap">
            <canvas #productCanvas></canvas>
          </div>
          <ul class="fo-product-legend fo-product-legend--stacked">
            @for (p of productBreakdown; track p.code) {
              <li
                class="fo-product-legend__row"
                [class.fo-product-legend__row--active]="selectedProductCode === p.code"
                role="button"
                tabindex="0"
                (click)="selectProductCode(p.code)"
                (keydown.enter)="selectProductCode(p.code)"
                (keydown.space)="$event.preventDefault(); selectProductCode(p.code)"
              >
                <span class="fo-product-swatch" [style.background]="p.color"></span>
                <span class="fo-product-code">{{ p.code }}</span>
                <span class="fo-product-spacer"></span>
                <span class="fo-product-meta">{{ p.count }}</span>
                <span class="fo-product-pct">({{ p.pct }}%)</span>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>

    <div class="row fleet-overview__row">
      <div class="col-lg-6 mb-3">
        <div class="fo-card">
          <div class="fo-card__head-actions">
            <h2 class="fo-card__heading mb-0">
              Fulfillment Trend (Last 6 months)
            </h2>
            <div class="fo-legend-inline">
              <span
                ><i class="fa fa-square fo-sq fo-sq--ship"></i> Shipped:
                {{ fulfillmentShippedSum }}</span
              >
              <span
                ><i class="fa fa-square fo-sq fo-sq--act"></i> Activated:
                {{ fulfillmentActivatedSum }}</span
              >
            </div>
          </div>
          <div class="fo-chart-tall">
            <canvas #fulfillmentCanvas></canvas>
          </div>
        </div>
      </div>
      <div class="col-lg-6 mb-3">
        <div class="fo-card">
          <div class="fo-card__head-actions">
            <h2 class="fo-card__heading mb-0">
              Config Distribution ({{ selectedProductCode }})
            </h2>
            <button type="button" class="btn btn-fo-link btn-fo-link--quiet">
              View Configs <i class="fa fa-arrow-right"></i>
            </button>
          </div>
          <div class="fo-chart-tall">
            <canvas #configCanvas></canvas>
          </div>
          <div class="text-right mt-2">
            <button type="button" class="btn btn-fo-link">
              View Reports <i class="fa fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <section class="fo-health-section">
      <div class="fo-health-section__head">
        <h2 class="fo-section-title">Device Health Status</h2>
        <button type="button" class="btn btn-fo-link">
          View Reports <i class="fa fa-arrow-right"></i>
        </button>
      </div>
      <div class="row">
        @for (h of healthCards; track h.key) {
          <div class="col-sm-6 col-xl-3 mb-3">
            <div
              class="fo-health-card"
              [ngClass]="'fo-health-card--' + h.key"
              [style.border-color]="h.border"
            >
              <div class="fo-health-card__top">
                <div class="fo-health-card__header">
                  <div
                  class="fo-health-card__icon-wrap"
                  [style.background]="h.iconBg"
                >
                  <!-- <i [class]="h.iconClass" aria-hidden="true"></i> -->
                  <img alt="" width="24" height="24" src="{{ h.iconUrl }}">
                </div>
                  <p class="fo-health-card__label">{{ h.label }}</p>
                </div>
                <span
                  class="fo-health-card__pct"
                  [style.background]="h.iconBg"
                  [style.color]="h.valueColor"
                  >{{ h.pct }}%</span
                >
              </div>
              <p
                class="fo-health-card__value"
                [style.color]="h.valueColor"
              >
                {{ h.value }}
              </p>
            </div>
          </div>
        }
      </div>
    </section>

    <section class="fo-table-section fo-card">
      <div class="fo-table-section__head">
        <h2 class="fo-section-title mb-0">Device List</h2>
        <div class="fo-search">
          <i class="fa fa-search"></i>
          <input
            type="search"
            class="form-control"
            placeholder="Search Devices"
            [(ngModel)]="deviceSearch"
            (ngModelChange)="devicePage = 1"
            name="deviceSearch"
          />
        </div>
      </div>
      <div class="table-responsive">
        <table class="table fo-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Serial Number</th>
              <th>ICCID</th>
              <th>Last Contact</th>
              <th>Config Age</th>
              <th>Latest Device Event</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            @for (d of pagedDevices; track d.serial; let i = $index) {
              <tr>
                <td>{{ (devicePage - 1) * devicePageSize + i + 1 }}</td>
                <td>{{ d.serial }}</td>
                <td>{{ d.iccid }}</td>
                <td>{{ d.lastContact }}</td>
                <td>{{ d.configAge }}</td>
                <td>{{ d.event }}</td>
                <td class="text-right">
                  <button
                    type="button"
                    class="btn btn-link fo-chevron"
                    aria-label="Open"
                    (click)="openDeviceDetails(d)"
                  >
                    <i class="fa fa-chevron-right"></i>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="fo-pagination">
        <button
          type="button"
          class="btn fo-page-btn"
          (click)="setPage(1)"
          [disabled]="devicePage === 1"
        >
          <i class="fa fa-angle-double-left"></i>
        </button>
        <button
          type="button"
          class="btn fo-page-btn"
          (click)="setPage(devicePage - 1)"
          [disabled]="devicePage === 1"
        >
          <i class="fa fa-angle-left"></i>
        </button>
        @for (p of pageNumbers; track p) {
          <button
            type="button"
            class="btn fo-page-btn"
            [class.fo-page-btn--active]="devicePage === p"
            (click)="setPage(p)"
          >
            {{ p }}
          </button>
        }
        <button
          type="button"
          class="btn fo-page-btn"
          (click)="setPage(devicePage + 1)"
          [disabled]="devicePage >= devicePageCount"
        >
          <i class="fa fa-angle-right"></i>
        </button>
        <button
          type="button"
          class="btn fo-page-btn"
          (click)="setPage(devicePageCount)"
          [disabled]="devicePage >= devicePageCount"
        >
          <i class="fa fa-angle-double-right"></i>
        </button>
      </div>
    </section>
  </div>

  @if (isSidebarOpen && selectedDevice) {
    <aside class="fo-sidebar">
      <div class="fo-sidebar__head">
        <div>
          <p class="fo-sidebar__serial">{{ selectedDevice.serial }}</p>
          <p class="fo-sidebar__sub">{{ selectedDevice.serial }}</p>
        </div>
        <button
          type="button"
          class="btn btn-link fo-sidebar__close"
          (click)="closeDeviceDetails()"
          aria-label="Close"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>

      <div class="fo-sidebar__status-row">
        <span class="fo-status-pill">
          <i class="fa fa-circle"></i>
          Communicating
        </span>
        <span class="fo-trip-pill">{{ selectedDevice.tripStatus }}</span>
      </div>

      <p class="fo-sidebar__last-contact">{{ selectedDevice.lastContact }}</p>

      <div class="fo-meter">
        <div class="fo-meter__label">
          <i class="fa fa-signal"></i>
          Signal Strength
          <strong>{{ selectedDevice.signalStrength }}%</strong>
        </div>
        <div class="fo-meter__track">
          <span
            class="fo-meter__fill"
            [style.width.%]="selectedDevice.signalStrength"
          ></span>
        </div>
      </div>

      <div class="fo-meter">
        <div class="fo-meter__label">
          <i class="fa fa-battery-full"></i>
          Battery Level
          <strong>{{ selectedDevice.batteryLevel }}%</strong>
        </div>
        <div class="fo-meter__track">
          <span
            class="fo-meter__fill"
            [style.width.%]="selectedDevice.batteryLevel"
          ></span>
        </div>
      </div>

      <section class="fo-telemetry">
        <h4 class="fo-sidebar__section-title">
          <i class="fa fa-line-chart"></i> Device Telemetry
        </h4>
        <div class="fo-telemetry-item">
          <i class="fa fa-map-marker"></i>
          <div>
            <label>Location</label>
            <p>{{ selectedDevice.location }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-barcode"></i>
          <div>
            <label>IMEI</label>
            <p>{{ selectedDevice.imei }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-credit-card"></i>
          <div>
            <label>ICCID</label>
            <p>{{ selectedDevice.iccid }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-cog"></i>
          <div>
            <label>Config Version</label>
            <p>{{ selectedDevice.configVersion }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-microchip"></i>
          <div>
            <label>Firmware Version</label>
            <p>{{ selectedDevice.firmwareVersion }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-qrcode"></i>
          <div>
            <label>Product Code</label>
            <p>{{ selectedDevice.productCode }}</p>
          </div>
        </div>
        <div class="fo-telemetry-item">
          <i class="fa fa-clock-o"></i>
          <div>
            <label>Uptime</label>
            <p>{{ selectedDevice.uptime }}</p>
          </div>
        </div>
      </section>

      <section class="fo-activity">
        <h4 class="fo-sidebar__section-title">
          <i class="fa fa-history"></i> Recent Activity
        </h4>
        @for (item of selectedDevice.recentActivity; track item.title + item.time) {
          <div class="fo-activity__item">
            <span class="fo-activity__dot"></span>
            <div>
              <p class="fo-activity__title">{{ item.title }}</p>
              <p class="fo-activity__time">{{ item.time }}</p>
            </div>
          </div>
        }
      </section>
    </aside>
  }
</div>
